import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus, Trash2 } from "lucide-react";
import { adminApi, formatError } from "@/lib/adminApi";
import { Checkbox, SectionHeader } from "@/pages/admin/ui";

const input = "w-full min-h-[44px] rounded-xl border border-line bg-white px-3 text-base";

function StaffRow({ s, onChange, onDelete }) {
  const [pin, setPin] = useState("");
  const patch = async (body, msg) => {
    try {
      onChange((await adminApi.patch(`/admin/staff/${s.id}`, body)).data);
      toast.success(msg);
      setPin("");
    } catch (e) {
      toast.error(formatError(e));
    }
  };
  return (
    <li className="rounded-2xl border border-line bg-white p-4 grid gap-3 md:grid-cols-[1fr_auto_auto_auto] md:items-center" data-testid={`staff-${s.username}`}>
      <div>
        <p className="font-semibold">{s.name} <span className="text-ink-muted font-normal">@{s.username}</span></p>
        <p className="text-xs text-ink-muted">{s.active ? "Aktif" : "Pasif"}</p>
      </div>
      <div className="flex gap-2">
        <input type="password" value={pin} onChange={(e) => setPin(e.target.value)} placeholder="Yeni PIN" aria-label={`${s.username} yeni PIN`} className={`${input} w-36`} data-testid={`staff-${s.username}-pin`} />
        <button type="button" disabled={pin.length < 6} onClick={() => patch({ password: pin }, "PIN güncellendi")} className="min-h-[44px] px-4 rounded-full border border-line text-sm font-semibold disabled:opacity-40" data-testid={`staff-${s.username}-pin-save`}>PIN değiştir</button>
      </div>
      <Checkbox id={`staff-active-${s.id}`} label="Aktif" checked={s.active} onChange={(v) => patch({ active: v }, v ? "Etkinleştirildi" : "Pasifleştirildi")} testId={`staff-${s.username}-active`} />
      <button type="button" onClick={() => onDelete(s)} aria-label={`${s.username} sil`} className="h-11 w-11 inline-flex items-center justify-center rounded-full hover:bg-[#FEF3F2] text-[#B42318]" data-testid={`staff-${s.username}-delete`}><Trash2 className="h-4 w-4" aria-hidden="true" /></button>
    </li>
  );
}

export default function StaffSection() {
  const [list, setList] = useState(null);
  const [f, setF] = useState({ username: "", name: "", password: "" });
  useEffect(() => { adminApi.get("/admin/staff").then(({ data }) => setList(data)).catch((e) => toast.error(formatError(e))); }, []);

  const create = async (e) => {
    e.preventDefault();
    try {
      const { data } = await adminApi.post("/admin/staff", f);
      setList([...list, data]);
      setF({ username: "", name: "", password: "" });
      toast.success("Görevli eklendi");
    } catch (err) {
      toast.error(formatError(err));
    }
  };
  const remove = async (s) => {
    if (!window.confirm(`${s.username} silinsin mi?`)) return;
    try {
      await adminApi.delete(`/admin/staff/${s.id}`);
      setList(list.filter((x) => x.id !== s.id));
    } catch (err) {
      toast.error(formatError(err));
    }
  };

  return (
    <section data-testid="admin-section-gorevliler">
      <SectionHeader title="Görevliler" text="Görevliler yalnızca /terminal ekranını kullanabilir; yönetim paneline ve yönetim API'lerine erişemez." />
      <form onSubmit={create} className="rounded-2xl border border-line bg-white p-5 grid gap-3 md:grid-cols-[1fr_1fr_1fr_auto] md:items-end mb-6" data-testid="staff-create-form">
        {[["username", "Kullanıcı adı", "text"], ["name", "Görünen ad", "text"], ["password", "PIN / şifre (en az 6)", "password"]].map(([k, l, type]) => (
          <label key={k} className="block text-sm font-semibold text-wood space-y-1">{l}
            <input type={type} value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })} required={k !== "name"} autoComplete="off" className={input} data-testid={`staff-create-${k}`} />
          </label>
        ))}
        <button type="submit" className="inline-flex items-center justify-center gap-2 min-h-[44px] px-5 rounded-full bg-forest text-cream text-sm font-semibold" data-testid="staff-create-submit"><Plus className="h-4 w-4" aria-hidden="true" /> Ekle</button>
      </form>
      {list === null && <p className="text-ink-muted">Yükleniyor…</p>}
      {list?.length === 0 && <p className="text-ink-muted" data-testid="staff-empty">Henüz görevli yok.</p>}
      <ul className="space-y-3" data-testid="staff-list">
        {list?.map((s) => <StaffRow key={s.id} s={s} onChange={(n) => setList(list.map((x) => (x.id === n.id ? n : x)))} onDelete={remove} />)}
      </ul>
      <p className="mt-6 text-sm text-ink-muted">Terminal adresi: <a href="/terminal" className="underline font-semibold text-forest" data-testid="staff-terminal-link">/terminal</a></p>
    </section>
  );
}
